module.exports = __webpack_public_path__ + "static/media/back.93b555fa.svg";